// extracted by mini-css-extract-plugin
export default {"tableContainer":"PricingTable_tableContainer__aTTMr","tableWrapper":"PricingTable_tableWrapper__ia+sv","table":"PricingTable_table__Ww1DT","area":"PricingTable_area__+7VfM"};